// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2HQL3","productName":"Table_productName__2kBSD"};